const PUBLIC_ENDPOINTS = [
    '/authenticate', 
    '/verify',
    '/refresh-token', 
    '/forgot-password', 
    '/sign-up',
    '/m/j',
    '/feedback',
    '/get-recording',
    '/get-recorded-meeting-info',
    '/sign-in',
    '/copy-record'
];

export default PUBLIC_ENDPOINTS